import { useNavigate } from 'react-router-dom'
import styles from './CVPage.module.css'

export function CVPage() {
  const navigate = useNavigate()

  const handleBack = () => {
    navigate('/')
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>Curriculum Vitae</h1>
        <div className={styles.cvContent}>
          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>Key Skills</h2>
            <div className={styles.skillList}>
              <div className={styles.skillItem}>
                <strong>Problem Decomposition</strong> - breaking a large technical problem into optimised subproblems that can be distributed across a team.
              </div>
              <div className={styles.skillItem}>
                <strong>Interpersonal Skills</strong> - managing technical relationships to source solutions to problems.
              </div>
              <div className={styles.skillItem}>
                <strong>Technical Problem Solving</strong> - comfortable in a broad range of technical capacities with a track record of fast deployment times without compromising safety and robustness, and capable of identifying areas where different tech can be used to enhance a business case.
              </div>
            </div>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>Experience</h2>

            <div className={styles.experienceItem}>
              <div className={styles.experienceHeader}>
                <h3 className={styles.experienceCompany}>Hudson River Trading</h3>
                <span className={styles.experienceDate}>MAR 2022 - PRESENT</span>
              </div>
              <div className={styles.experienceRole}>Core Developer, Full Stack Developer</div>
              <div className={styles.experienceList}>
                <div className={styles.experienceListItem}>Owned the build out of a ground-up tool suite for intraday trading management; risk management; and strategy management that covers all of HRT's daily trading in React and Python</div>
                <div className={styles.experienceListItem}>Responsible for the strategic direction and infrastructure build out of two different React based monorepos for two different business areas and unifying them</div>
                <div className={styles.experienceListItem}>Implemented a variety of novel solutions to overcome fundamental limitations of modern browser implementations to allow for more failure-resilient trading monitoring</div>
                <div className={styles.experienceListItem}>Built a python database data mocking utility that decreased test writing time by 90%</div>
                <div className={styles.experienceListItem}>Responsible for managing relations and project planning with various senior stakeholders at HRT</div>
              </div>
            </div>

            <div className={styles.experienceItem}>
              <div className={styles.experienceHeader}>
                <h3 className={styles.experienceCompany}>Palantir Technologies</h3>
                <span className={styles.experienceDate}>JUN 2020 - AUG 2020, AUG 2021 - FEB 2022</span>
              </div>
              <div className={styles.experienceRole}>Forward Deployed Engineer, formerly Intern</div>
              <div className={styles.experienceList}>
                <div className={styles.experienceListItem}>Owned the maintenance and improving of the English COVID-19 Vaccination Ordering Platform - from back end reporting integrating large datasets using PySpark and Java to building front end dashboards that 1000+ users use for critical work daily.</div>
                <div className={styles.experienceListItem}>Regular query plan level optimisation with Spark execution in a proprietary Kubernetes environment hosted both on premises and on AWS.</div>
                <div className={styles.experienceListItem}>Extremely agile development environment focused on adapting rapidly to business/customer needs and building functional, stable tools in short timeframes.</div>
              </div>
            </div>

            <div className={styles.experienceItem}>
              <div className={styles.experienceHeader}>
                <h3 className={styles.experienceCompany}>Victor One Risk Management</h3>
                <span className={styles.experienceDate}>SEP 2020 - PRESENT</span>
              </div>
              <div className={styles.experienceRole}>Technical Director</div>
              <div className={styles.experienceList}>
                <div className={styles.experienceListItem}>Co-founded a physical security firm that connected technology with a resistant industry to cause significant disruption to the market. Growing from an initial investment of 5,000 GBP to a valuation of more than 500,000 GBP.</div>
                <div className={styles.experienceListItem}>Constructed scalable internal tools in React, Node.JS, utilising ORM tools and PostgreSQL.</div>
              </div>
            </div>

            <div className={styles.experienceItem}>
              <div className={styles.experienceHeader}>
                <h3 className={styles.experienceCompany}>DX Debating</h3>
                <span className={styles.experienceDate}>JUL 2020 - PRESENT</span>
              </div>
              <div className={styles.experienceRole}>Managing Director</div>
              <div className={styles.experienceList}>
                <div className={styles.experienceListItem}>Co-founded a startup rapidly in the beginning stages of the COVID-19 pandemic to run for-profit debating events internationally using NodeJS, Public APIs, and Django.</div>
                <div className={styles.experienceListItem}>Grew to be the largest for-profit debate organisation throughout the pandemic organising eight international competitions for thousands of participants across five continents.</div>
              </div>
            </div>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>Education</h2>
            <div className={styles.educationItem}>
              <div className={styles.educationHeader}>
                <h3 className={styles.educationInstitution}>Durham University</h3>
                <span className={styles.educationDate}>CLASS OF 2021</span>
              </div>
              <div className={styles.educationDegree}>First Class MEng Computer Science</div>
              <div className={styles.educationList}>
                <div className={styles.educationListItem}>84% Masters' Thesis - Evolutionary Regression Trees for Analyst-Augmented Autonomous ForEx Trading</div>
                <div className={styles.educationListItem}>1:1 Bachelors' Dissertation - Correlating ForEx Price Changes with Twitter Sentiment</div>
                <div className={styles.educationListItem}>Modules covering distributed computing, Blockchain & Cryptocurrencies, NLP, Automated Verification, and probabilistic methods</div>
              </div>
            </div>
          </section>
        </div>
        <button onClick={handleBack} className={styles.backButton}>
          Back to Terminal
        </button>
      </div>
    </div>
  )
}

